// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.table-dialog .el-input-group__append {\r\n  padding: 0 14px;\n}\n.table-dialog .el-input__suffix-inner {\r\n  line-height: 28px;\n}\n.el-icon-circle-close {\r\n  cursor: pointer;\n}\r\n", ""]);
// Exports
module.exports = exports;
